import axiosInstance from '../api';

export interface PushPublicKey {
  publicKey: string;
  /** False when the server has no VAPID pair — the UI must not offer to subscribe. */
  configured: boolean;
}

export interface PushSubscriptionRecord {
  id: string;
  endpoint: string;
  userAgent: string | null;
  createdAt: string;
  lastSeenAt: string | null;
  revokedAt: string | null;
}

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  userAgent?: string;
}

export interface PushTestResult {
  sent: number;
  revoked: number;
  failed: number;
  revokedEndpoints: string[];
}

const pushSubscriptionsService = {
  /**
   * The VAPID public key is served rather than bundled, so rotating the pair does not
   * require a frontend rebuild.
   */
  getPublicKey: async () => {
    const res = await axiosInstance.get<PushPublicKey>(
      '/push-subscriptions/public-key'
    );
    return res.data;
  },

  /** Register (or re-register) this browser. The server upserts on `endpoint`. */
  create: async (data: PushSubscriptionPayload) => {
    const res = await axiosInstance.post<PushSubscriptionRecord>(
      '/push-subscriptions',
      data
    );
    return res.data;
  },

  /** Unregister this browser. The browser knows its endpoint, not the server's row id. */
  remove: async (endpoint: string) => {
    const res = await axiosInstance.delete<PushSubscriptionRecord>(
      '/push-subscriptions',
      {
        params: { endpoint },
      }
    );
    return res.data;
  },

  /** Admin-only: send a test push to every device on the caller's account. */
  sendTest: async () => {
    const res = await axiosInstance.post<PushTestResult>(
      '/push-subscriptions/test',
      {}
    );
    return res.data;
  },
};

export default pushSubscriptionsService;
